import 'react-dropdown/style.css';

export default function Soundtracks() {
  return <div>SOUNDTRACKS</div>;
}
